import React, { useEffect, useRef, useState } from "react";
import { getUpfrontPaymentReport } from "../../store/actions/paymentActions.js";
import { useDispatch } from "react-redux";
import { convertDateInFormat } from "../../utils/utils.js";
import { DateFilterComponent } from "../UpfrontPayment/FilterComponent.js";
import { generatePdf } from "../../utils/generatePdf.js";
import logo from "../../Assets/logo/logo_2x.svg";
import NewDataTable from "../../components/NewTable/index.js";
const UpfrontPaymentReport = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [selectedRange, setSelectedRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [paymentReportData, setPaymentReportData] = useState([]);
  const [proposalNumber, setProposalNumber] = useState("");
  const [proposalNumberFilter, setProposalNumberFilter] = useState("");
  const [fromDate, setFromDate] = useState(false);
  const [toDate, setToDate] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);

  const dispatch = useDispatch();
  const slipRef = useRef(null);

  useEffect(() => {
    callUpfrontPaymentReportApi();
  }, [currentPage, pageSize, proposalNumberFilter]);

  const applyDateRange = async (startDate, endDate) => {
    setSelectedRange({ startDate, endDate });
    const payload = {
      fromDate: convertDateInFormat(startDate, "DD-MM-YYYY")
        ? convertDateInFormat(startDate, "DD-MM-YYYY")
        : "",
      toDate: convertDateInFormat(endDate, "DD-MM-YYYY")
        ? convertDateInFormat(endDate, "DD-MM-YYYY")
        : "",
      proposalNumber: proposalNumberFilter ? proposalNumberFilter : "",
      page: currentPage,
      size: pageSize,
      export: false,
    };
    let resp = await dispatch(getUpfrontPaymentReport(payload));
    if (resp && resp.body) {
      setPaymentReportData(resp.body.data);
      setTotalRecords(resp.body.totalRecords);
    }
  };

  const callUpfrontPaymentReportApi = async (exportExcel = false) => {
    const payload = {
      fromDate: convertDateInFormat(selectedRange?.startDate, "DD-MM-YYYY")
        ? convertDateInFormat(selectedRange?.startDate, "DD-MM-YYYY")
        : "",
      toDate: convertDateInFormat(selectedRange?.endDate, "DD-MM-YYYY")
        ? convertDateInFormat(selectedRange?.endDate, "DD-MM-YYYY")
        : "",
      proposalNumber: proposalNumberFilter ? proposalNumberFilter : "",
      page: currentPage,
      size: pageSize,
      export: exportExcel,
    };
    const resp = await dispatch(getUpfrontPaymentReport(payload));
    if(exportExcel && resp && resp.body){
      return resp?.body?.data;
    }
    if (resp && resp.body) {
      setPaymentReportData(resp.body.data);
      setTotalRecords(resp.body.totalRecords);
    }
  };

  return (
    <div className="upfront-payment-report">
      <h1>Upfront Payment Report</h1>
      <div className="filters">
        <div className="comp1">
          <div className="filter-component">
            <div className="filter-options">
              <div className="filter">
                <label>{`Proposal Number: `}</label>
                <input
                  type="text"
                  className="filter-select"
                  value={proposalNumber}
                  inputMode="numeric"
                  placeholder="Enter 10-digit proposal no"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setProposalNumber(value);
                    if (value.length === 10) {
                      setProposalNumberFilter(value);
                    }
                    if(value.length === 0){
                      setProposalNumberFilter("");
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{ textAlign: "right" }} className="comp3">
          <DateFilterComponent
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            applyDateRange={applyDateRange}
            selectedRange={selectedRange}
            setSelectedRange={setSelectedRange}
          />
        </div>
      </div>
        {paymentReportData && paymentReportData.length > 0 && (
          <div className="reconciliation-table-wrapper">
            <NewDataTable
              cellHeaders={[
                "Proposal No",
                "Branch Code",
                "Channel",
                "Subchannel",
                "Acknowledge Status",
                "Reconciliation",
                "Banking",
                "DCR Status",
                "Cheque/DD No",
                "Payment Method",
              ]}
              keys={[
                "proposalNumber",
                "branchCode",
                "channel",
                "subChannel",
                "acknowledgeStatus",
                "reconcile",
                "banking",
                "dcrCalled",
                "chequeOrDdNumber",
                "paymentMethod",
              ]}
              data={paymentReportData}
              fileName="Upfront-Payment-Report"
              addSerialNo={true}
              showExcelDownload={true}
              PerPageApiData={false}
              paginationItems={paymentReportData}
              alwaysShown={false}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              totalRecords={totalRecords}
              callUpfrontPaymentReportApi={callUpfrontPaymentReportApi}
            />
          </div>
        )}
    </div>
  );
};

export default UpfrontPaymentReport;
